import UpdatePassword from '@/features/auth/components/UpdatePassword';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/profile/change-password')({
	component: UpdatePassword,
});
